import React, { useState } from 'react';

function Contact() {
  // 1. Создаем стейт для хранения имени
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault(); // Чтобы страница не перезагружалась при отправке
    alert(`Спасибо за сообщение, ${name}!`);
  }
  const [email, setEmail] = useState("");

  return (
    <div className="contact-container">
      <h2>Contact Us</h2>
      <form onSubmit={handleSubmit}>
        <input 
          type="text" 
          placeholder="Your Name..." 
          value={name} // 2. Привязываем значение к стейту
          onChange={(e) => setName(e.target.value)} // 3. Обновляем стейт при вводе
        />
        <input 
             type="email" 
             placeholder="Your Email..." 
             value={email} 
             onChange={(e) => setEmail(e.target.value)} 
            required 
        />
        <button type="submit">Send</button>

      </form>
    </div>
  );
}

export default Contact;